import { createSvgIcon } from '@mui/material';

const VideoIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <g clip-path="url(#clip0_1078_27771)">
        <rect width="30" height="30" rx="15" fill="#EBEAFF" />
        <path
          d="M15 -1.25C6.03 -1.25 -1.25 6.03 -1.25 15C-1.25 23.97 6.03 31.25 15 31.25C23.97 31.25 31.25 23.97 31.25 15C31.25 6.03 23.97 -1.25 15 -1.25ZM11.75 20.6875V9.3125C11.75 8.64625 12.5138 8.25625 13.05 8.6625L20.6388 14.35C21.0775 14.675 21.0775 15.325 20.6388 15.65L13.05 21.3375C12.5138 21.7437 11.75 21.3538 11.75 20.6875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1078_27771">
          <rect width="30" height="30" rx="15" fill="white" />
        </clipPath>
      </defs>
    </>,
    'VideoIcon',
  );
  return (
    <IconCmp
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    />
  );
};
export default VideoIcon;
